<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <!-- <div>
          <v-btn @click="SignOut()">登出</v-btn>
        </div>
        <div>使用者 : {{ username }}</div>
        <v-btn @click="Token_UsernameApi()">Get使用者</v-btn>
        <v-btn @click="Token_RefreshApi()">Refresh</v-btn> -->
        <div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
      </v-col>
      <v-col>
        <v-form
          ref="form"
          v-model="componentData.formSetting.valid"
          lazy-validation
        >
          <v-text-field
            outlined
            hide-details="auto"
            v-model="signInDate.email"
            :label="componentData.formSetting.input1.label"
            :placeholder="componentData.formSetting.input1.placeholder"
            :rules="componentData.formSetting.input1.rules"
            :error-messages="componentData.formSetting.input1.errorMsg"
            @focus="ResetValidation"
          ></v-text-field>
          <div class="py-2"></div>
          <v-text-field
            outlined
            hide-details="auto"
            v-model="signInDate.password"
            :label="componentData.formSetting.input2.label"
            :placeholder="componentData.formSetting.input2.placeholder"
            :rules="componentData.formSetting.input2.rules"
            :error-messages="componentData.formSetting.input2.errorMsg"
            :type="pwdVisiable ? 'text' : 'password'"
            :append-icon="pwdVisiable ? eyeIcon.eyeOff : eyeIcon.eyeOn"
            @keyup.enter="SignIn()"
            @click:append="EyeSwitch()"
            @focus="ResetValidation"
          ></v-text-field>
        </v-form>
        <div align="right">
          <v-btn
            text
            color="deep-purple accent-3"
            class="pa-0 text-decoration-underline"
            plain
            @click="GoResetPwd()"
          >
            {{ componentData.forgotPwd }}
          </v-btn>
        </div>
        <div class="text-caption text--secondary mt-4">
          本網站採用reCAPTCHA 保護機制
          <a href="https://policies.google.com/privacy">隱私權</a> &
          <a href="https://policies.google.com/terms">條款</a>
          <div v-show="false">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a>
            apply.
          </div>
        </div>

        <div class="py-4"></div>
        <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="SignIn()"
        >
          <span class="mx-2 text-capitalize">{{ componentData.login }}</span>
        </v-btn>

        <v-row class="d-flex">
          <v-col cols="6">
            <v-divider class="my-10"></v-divider>
          </v-col>
          <div class="my-11 body-2 text--disabled">
            {{ componentData.or }}
          </div>
          <v-col>
            <v-divider class="my-10"></v-divider>
          </v-col>
        </v-row>

        <v-btn
          block
          large
          outlined
          class="btn-gray-border"
          :loading="componentData.googleLoading"
          @click="GoogleSignIn()"
        >
          <v-img
            contain
            max-height="22.8"
            max-width="24"
            :src="componentData.googleLogo"
          ></v-img
          ><span class="mx-2 text-capitalize">{{
            componentData.googleLogin
          }}</span>
        </v-btn>

        <!-- <div class="py-4"></div>
         <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="SignIn()"
        >
          <span class="mx-2 text-capitalize">{{ componentData.login }}</span>
        </v-btn> -->
        <div class="py-4"></div>
        <div>
          <span class="text-body-2">{{ componentData.noAcc }} </span>

          <v-btn
            text
            color="deep-purple accent-3"
            class="pa-0 pb-1 text-decoration-underline"
            plain
            @click="GoSignUp()"
          >
            {{ componentData.freeSignup }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  Token_SignIn,
  Google_Login,
  Google_GetSiteToken,
  Token_LogOut,
  Token_Username,
  Token_Refresh,
} from "@/apis/api";
import axios from "axios";

export default {
  name: "SignIn",
  data() {
    return {
      loginStatus: "",
      username: "",
      token: "",
      componentData: {
        title: "會員登入",
        formSetting: {
          valid: true,
          input1: {
            label: "帳號(電子信箱)",
            placeholder: "email",
            rules: [
              (v) => !!v || "此欄位必填",
              (v) =>
                /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(
                  v
                ) || "格式錯誤，請重新輸入",
            ],
            errorMsg: "",
          },
          input2: {
            label: "密碼",
            placeholder: "請輸入",
            rules: [
              (v) => !!v || "此欄位必填",
              (v) => v?.length >= 6 || "長度最少需為6個字元",
              (v) => v?.length <= 20 || "長度需少於20個字元",
              (v) => /^[a-zA-Z0-9~!@#$%&_?]+$/.test(v) || "密碼格式錯誤",
            ],
            errorMsg: "",
          },
        },
        forgotPwd: "忘記密碼?",
        or: "或",
        googleLogo: require("@/assets/image/components/Google Icon.svg"),
        googleLogin: "Google 登入",
        login: "登入",
        noAcc: "還沒有小芋頭帳號?",
        freeSignup: "免費註冊",
        loading: false,
        googleLoading: false,
      },
      signInDate: {
        email: null,
        password: null,
        recaptchaToken: "",
      },
      pwdVisiable: false,
      eyeIcon: {
        eyeOn: "mdi-eye",
        eyeOff: "mdi-eye-off",
      },
    };
  },
  created() {
    // 測試登入狀態
    this.loginStatus = this.$store.state.signinStatus;
    this.username = this.$store.state.username;
  },
  mounted() {
    if (localStorage.getItem("_acc") !== null) {
      this.signInDate.email = localStorage.getItem("_acc");
      this.signInDate.password = localStorage.getItem("_pwd");
    }

    if (this.$route.query.ivtem) {
      localStorage.setItem(
        "inviterQuery",
        `cmid=${this.$route.query.cmid}&ivtem=${this.$route.query.ivtem}`
      );
    } else {
      localStorage.removeItem("inviterQuery");
    }

    var guid = this.$route.query.guid;
    // Google登入轉址回來要從快取拿token需要的Guid存sessionStorage
    if (guid !== undefined) {
      // Guid塞進sessionStorage
      sessionStorage.setItem("_guid", guid);
      // 用Guid拿暫存在快取的token
      this.GetSiteToken(guid);
    }
  },
  methods: {
    // 顯示密碼切換
    EyeSwitch() {
      this.pwdVisiable = !this.pwdVisiable;
    },
    // 清除表單驗證
    ResetValidation() {
      // this.$refs.form.resetValidation();
      this.componentData.formSetting.input1.errorMsg = "";
      this.componentData.formSetting.input2.errorMsg = "";
    },
    // 平台登入取回token
    async SignIn() {
      this.$refs.form.validate();
      if (!this.$refs.form.validate()) return false;
      this.componentData.loading = true;
      this.signInDate.recaptchaToken = await this.GetRecaptchaToken();
      localStorage.removeItem("_token");
      // API
      Token_SignIn(this.signInDate)
        .then((res) => {
          localStorage.setItem("_token", res.data.token);
          localStorage.setItem("_acc", this.signInDate.email);
          localStorage.setItem("_pwd", this.signInDate.password);
          this.GetEmailEncrypt(res.data.token);
          this.$emit("token", res.data.token);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.message === "密碼錯誤，請重新輸入") {
            // 密碼錯
            this.componentData.formSetting.input2.errorMsg =
              err.response.data.message;
          } else {
            // 帳號錯
            this.componentData.formSetting.input1.errorMsg =
              err.response.data.message;
          }

          this.componentData.loading = false;
        });
    },
    // Google 登入
    GoogleSignIn() {
      this.componentData.googleLoading = true;
      Google_Login()
        .then((res) => {
          location.replace(res.data);
          //   console.log(res);
          this.componentData.googleLoading = false;
        })
        .then((err) => {
          console.log(err);
          this.componentData.googleLoading = false;
        });
    },
    // Google 驗證 recaptcha v3
    async GetRecaptchaToken() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("login");
      return token;
    },
    // 用guid換token
    GetSiteToken(letter) {
      Google_GetSiteToken(letter)
        .then((res) => {
          localStorage.setItem("_token", res.data.token);
          this.GetEmailEncrypt(res.data.token);
          this.$emit("token", res.data.token);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 取得加密email
    GetEmailEncrypt(token) {
      const apiBaseUrl = process.env.VUE_APP_MAIN_API_BASE_URL;
      const header = {
        Authorization: "Bearer " + token,
      };
      const myRequest = axios.create({
        baseURL: apiBaseUrl,
        headers: header,
      });
      myRequest
        .get(`Token/emailEncrypt`)
        .then((res) => {
          console.log(res);
          this.username = res.data;
          this.componentData.loading = false;
          this.GoFromSite(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 從哪來回哪去
    GoFromSite(emailEncrypt) {
      // 串加密信箱string過去
      if (this.$route.query.ivtem) {
        // 再本系統上註冊登入帳號 收到邀請連結會帶query 直接轉回去表單
        window.location.href =
          this.$store.state.fromSite.url +
          "/writeInvitedForm?emailEncrypt=" +
          emailEncrypt +
          "&cmid=" +
          this.$route.query.cmid +
          "&ivtem=" +
          this.$route.query.ivtem;
      } else if (localStorage.getItem("inviterQuery")) {
        // 用google登入的話會先存在localStorage 再從localStorage取 直接轉回去表單
        let query = localStorage.getItem("inviterQuery");
        localStorage.removeItem("inviterQuery");
        window.location.href =
          this.$store.state.fromSite.url +
          "/writeInvitedForm?emailEncrypt=" +
          emailEncrypt +
          "&" +
          query;
      } else {
        let fromCmid = localStorage.getItem("fromCmid");
        if (fromCmid) {
          localStorage.removeItem("fromCmid");
          window.location.href = `${this.$store.state.fromSite.url}/writeInvitedForm?cmid=${fromCmid}&uem=${emailEncrypt}`;
        } else {
          window.location.href =
            this.$store.state.fromSite.url + "?emailEncrypt=" + emailEncrypt;
          //   window.location.href = this.$store.state.fromSite.url;
        }
      }
    },
    // 回平台首頁
    GoBackHome() {
      this.$router.push({ name: "Home" });
    },
    // 轉註冊頁面
    GoSignUp() {
      this.$emit("switch", "SignUp");
    },
    // 轉重設密碼頁面
    GoResetPwd() {
      this.$emit("switch", "ResetPwd");
    },
    //登出
    SignOut() {
      Token_LogOut()
        .then((res) => {
          console.log(res);
          //     this.$router.go(0);
        })
        .catch();
      //   localStorage.setItem("_token", null);
      //   setTimeout(() => {
      //     this.$router.go(0);
      //   }, 1000);
    },
    Token_UsernameApi() {
      Token_Username()
        .then((res) => {
          console.log(res);
          this.username = res.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    Token_RefreshApi() {
      Token_Refresh()
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err.response);
          //   if(err.response.status === 401){

          //   }
        });
    },
  },
};
</script>
